import React from "react";
import moment from 'moment';

export default function DateFormatted(props) {

    return (
        <>
            {props.date ? moment(props.date).format("DD.MM.YYYY") : '-'}
        </>
    );
}